import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { useTransferMoneyContext } from '../hooks/useTransferMoneyContext';

export interface TransferAccountDTO {
  accountType: string;
  balance: number;
  id: string;
  institutionName: string;
  name: string;
}

const fetchTransferAccountsOptions = async (
  clientId: string,
  managedAccountId: string,
): Promise<TransferAccountDTO[]> =>
  authFetch(
    urlWithParams(`/Consumer/AcatsTransfers/ListAccounts`, {
      clientId,
      managedAccountId,
    }),
  );

export const useTransferAccountsOptionsQuery = () => {
  const { clientId, managedAccountId } = useTransferMoneyContext();

  return useQuery(
    queryKeys.transferAccountsOptions(clientId, managedAccountId),

    () => fetchTransferAccountsOptions(clientId, managedAccountId),
  );
};
